module.exports = __webpack_public_path__ + "img/egyptpost.1927b000.jpg";